import { CheckoutControl } from './components/checkout-control';
import { CheckoutProps } from './types';

export const Checkout = ({ stripePublishableKey }: CheckoutProps) => {
  const renderCheckout = () => (
    <CheckoutControl stripePublishableKey={stripePublishableKey} />
  );

  return <>{renderCheckout()}</>;
};
